package ru.villawonka.app.presentation.design.components

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.*
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.painterResource
import org.jetbrains.compose.ui.tooling.preview.Preview
import ru.villawonka.app.presentation.design.extensions.AppSpacer
import ru.villawonka.app.presentation.design.theme.AppColors
import ru.villawonka.app.presentation.design.theme.AppTextStyles
import ru.villawonka.app.presentation.design.theme.AppTheme
import villawonka.composeapp.generated.resources.Res
import villawonka.composeapp.generated.resources.ic_plus_24

@Composable
fun AppFilledChip(
    modifier: Modifier = Modifier,
    text: String,
    iconRes: DrawableResource? = null,
    disabled: Boolean = false,
    focused: Boolean = false,
    onClick: (() -> Unit)? = null,
) {
    val backgroundColor = if (disabled) {
        MaterialTheme.colors.filledChipsBackgroundDisabled
    } else {
        if (focused) {
            MaterialTheme.colors.filledChipsBackgroundFocused
        } else {
            MaterialTheme.colors.filledChipsBackgroundEnabled
        }
    }
    val contentColor = if (disabled) {
        MaterialTheme.colors.filledChipsContentDisabled
    } else {
        if (focused) {
            MaterialTheme.colors.filledChipsContentFocused
        } else {
            MaterialTheme.colors.filledChipsContentEnabled
        }
    }

    Box(
        modifier = modifier
            .clickable(
                interactionSource = null,
                indication = null
            ) {
                onClick?.invoke()
            }
            .background(
                color = backgroundColor,
                shape = RoundedCornerShape(8.dp),
            )
            .padding(
                start = if (iconRes != null) 8.dp else 16.dp,
                end = 16.dp,
                top = 8.dp,
                bottom = 8.dp,
            ),
    ) {
        Row(
            verticalAlignment = Alignment.CenterVertically
        ) {
            iconRes?.let {
                Icon(
                    painter = painterResource(iconRes),
                    contentDescription = null,
                    modifier = Modifier.size(24.dp),
                    tint = contentColor,
                )
                AppSpacer(6.dp)
            }
            Text(
                text = text,
                color = contentColor,
                style = AppTextStyles.labelMediumMedium
            )
        }
    }
}

private val Colors.filledChipsContentEnabled: Color
    get() = if (isLight) AppColors.grayLight950 else AppColors.grayDark50

private val Colors.filledChipsContentDisabled: Color
    get() = if (isLight) AppColors.grayDark700 else AppColors.grayDark500

private val Colors.filledChipsContentFocused: Color
    get() = if (isLight) AppColors.grayLight50 else AppColors.grayDark50

private val Colors.filledChipsBackgroundEnabled: Color
    get() = if (isLight) AppColors.grayLight100 else AppColors.grayDark950

private val Colors.filledChipsBackgroundDisabled: Color
    get() = if (isLight) AppColors.grayLight900 else AppColors.grayDark700

private val Colors.filledChipsBackgroundFocused: Color
    get() = if (isLight) AppColors.blue500 else AppColors.blue500


@Preview
@Composable
fun AppFilledChipPreview() {
    Column {
        Row {
            Column(
                modifier = Modifier
                    .background(Color.White)
                    .padding(16.dp)
            ) {

                AppTheme(isDarkTheme = false) {

                    // enabled

                    AppFilledChip(
                        text = "Enabled",
                    )
                    AppSpacer(16.dp)

                    // focused

                    AppFilledChip(
                        text = "Enabled",
                        focused = true,
                    )
                    AppSpacer(16.dp)

                    // with icon

                    AppFilledChip(
                        text = "Enabled",
                        iconRes = Res.drawable.ic_plus_24
                    )
                    AppSpacer(16.dp)

                    // disabled

                    AppFilledChip(
                        text = "Disabled",
                        disabled = true,
                    )
                    AppSpacer(16.dp)
                    AppFilledChip(
                        text = "Disabled",
                        iconRes = Res.drawable.ic_plus_24,
                        disabled = true,
                    )
                }
            }
            Column(
                modifier = Modifier
                    .background(Color.DarkGray)
                    .padding(16.dp)
            ) {

                AppTheme(isDarkTheme = true) {

                    // enabled

                    AppFilledChip(
                        text = "Enabled",
                    )
                    AppSpacer(16.dp)

                    // focused

                    AppFilledChip(
                        text = "Enabled",
                        focused = true,
                    )
                    AppSpacer(16.dp)

                    // with icon

                    AppFilledChip(
                        text = "Enabled",
                        iconRes = Res.drawable.ic_plus_24
                    )
                    AppSpacer(16.dp)

                    // disabled

                    AppFilledChip(
                        text = "Disabled",
                        disabled = true,
                    )
                    AppSpacer(16.dp)
                    AppFilledChip(
                        text = "Disabled",
                        iconRes = Res.drawable.ic_plus_24,
                        disabled = true,
                    )
                }
            }
        }
    }
}